// src/admin/LandingPageTemplates.js

const DEFAULT_IMAGE = 'https://studio.littlehibba.com/images/sajeda/6.jpg';

export const getTemplateModules = (templateType) => {
    const now = Date.now();
    let newModules = [];

    switch (templateType) {
        // ----------------------------------------------------
        // 1. PREMIUM AUTHOR PROFILE 
        // ----------------------------------------------------
        case 'premium_author':
            newModules = [
                { 
                    id: now, 
                    type: 'html', 
                    order: 0,
                    content: `<!-- Custom Styles -->
<style>
  .bg-premium-pattern { background-color: #f2f7fa; background-image: radial-gradient(#cfdbe6 1.5px, transparent 1.5px); background-size: 28px 28px; }
  .classy-heading { font-family: 'Playfair Display', serif; color: #1a365d; }
  .text-reading { font-size: 1.15rem; line-height: 1.8; color: #4a5568; }
  .badge-classy { background-color: #e2eff5; color: #1a365d; font-weight: 600; letter-spacing: 1px; padding: 8px 18px; border-radius: 50px; display: inline-block; }
</style>

<!-- Hero Section -->
<div class="bg-premium-pattern py-5">
  <div class="container py-5">
    <div class="row align-items-center">
      <div class="col-lg-6 pe-lg-5 mb-5 mb-lg-0">
        <span class="badge-classy text-uppercase mb-3">Author Profile</span>
        <h1 class="display-3 classy-heading fw-bold mb-4">Hello, I am [Name]</h1>
        <div class="text-reading">
          <p>I have always loved the way stories are created and shared. You can write your own journey, vision, and what you want to offer your readers right here.</p>
          <p class="fw-bold text-dark mt-4 border-start border-4 border-warning ps-3 py-2">
            My goal is to share the truth about the industry and create brand new stories...
          </p>
        </div>
      </div>
      <div class="col-lg-6 text-center">
        <img src="${DEFAULT_IMAGE}" alt="Author Portrait" class="img-fluid rounded-5 shadow-lg" style="max-height: 75vh; object-fit: cover;" />
      </div>
    </div>
  </div>
</div>`
                },
                { 
                    id: now + 1, 
                    type: 'html', 
                    order: 1,
                    content: `<!-- CTA / Contact Footer -->
<div class="py-5" style="background-color: #1a365d;">
  <div class="container text-center text-white py-5">
    <h2 class="classy-heading text-white display-4 mb-4">Ready to Write Your Own Story?</h2>
    <p class="lead mb-5 mx-auto" style="max-width: 700px; opacity: 0.9; line-height: 1.8;">
      Whether you want to publish your first book or find your place in the industry, I am here to guide you.
    </p>
    <a href="/contact" class="btn btn-light btn-lg px-5 py-3 rounded-pill fw-bold shadow-lg text-primary text-uppercase" style="letter-spacing: 2px;">
      Get in Touch
    </a>
  </div>
</div>`
                }
            ];
            break;

        // ----------------------------------------------------
        // 2. PREMIUM BOOK LAUNCH 
        // ----------------------------------------------------
        case 'premium_book':
            newModules = [
                { 
                    id: now, 
                    type: 'html', 
                    order: 0,
                    content: `<!-- Custom Styles -->
<style>
  .bg-premium-pattern { background-color: #f2f7fa; background-image: radial-gradient(#cfdbe6 1.5px, transparent 1.5px); background-size: 28px 28px; }
  .classy-heading { font-family: 'Playfair Display', serif; }
</style>

<!-- Book Title and Flipbook/Cover Area -->
<div class="bg-premium-pattern pb-5">
  <div class="container px-4 text-center" style="padding-top: 80px; max-width: 1200px;">
    <span class="badge px-4 py-2 rounded-pill fw-bold text-uppercase mb-3" style="background-color: #d8efff; color: #0056b3; letter-spacing: 1px;">
      NEW RELEASE
    </span>
    <h1 class="fw-bolder mb-3 text-dark classy-heading" style="font-size: 3.5rem; letter-spacing: -0.02em;">
      Your Book Title Here
    </h1>
    <p class="text-secondary mx-auto mb-5" style="font-size: 1.2rem; line-height: 1.8; max-width: 850px;">
      Write a short and compelling description text that will grab the reader's attention, spark curiosity, and encourage them to purchase the book.
    </p>
    <div class="mx-auto w-100" style="max-width: 1000px;">
      <img src="${DEFAULT_IMAGE}" alt="Book Cover" class="img-fluid rounded-4 shadow-lg border border-light" />
      <!-- Note: You can delete the img tag above and paste your Iframe code here instead -->
    </div>
  </div>
</div>`
                },
                { 
                    id: now + 1, 
                    type: 'html', 
                    order: 1,
                    content: `<!-- Premium Audio Player Area -->
<div class="bg-white py-5">
  <div class="container px-4" style="max-width: 1200px;">
    <div class="p-4 rounded-4 shadow-sm border border-light border-start border-5 border-warning mx-auto bg-light" style="max-width: 800px;">
      <div class="d-flex align-items-center justify-content-center mb-3">
         <h4 class="mb-0 fw-bold text-dark classy-heading">Listen to the Story</h4>
      </div>
      <audio controls class="w-100 shadow-sm rounded-pill mt-2" style="height: 50px;">
         <source src="YOUR_AUDIO_FILE_LINK_HERE" type="audio/mpeg" />
      </audio>
    </div>
  </div>
</div>`
                },
                { 
                    id: now + 2, 
                    type: 'html', 
                    order: 2,
                    content: `<!-- CTA / Purchase Footer -->
<div class="py-5 w-100" style="background-color: #1a365d;">
  <div class="container text-center text-white py-5">
    <h2 class="classy-heading text-white display-4 mb-4">Bring the Story Home</h2>
    <p class="lead mb-5 mx-auto" style="max-width: 700px; opacity: 0.9; line-height: 1.8;">
      Order your physical copy today and embark on this wonderful journey with your children.
    </p>
    <a href="#" target="_blank" class="btn btn-light btn-lg px-5 py-3 rounded-pill fw-bold shadow-lg text-primary text-uppercase" style="letter-spacing: 2px;">
      ORDER BOOK NOW
    </a>
  </div>
</div>`
                }
            ];
            break;

        // ----------------------------------------------------
        // 3. EVENT TEMPLATE
        // ----------------------------------------------------
        case 'event_page':
            newModules = [
                { id: now, type: 'text', content: '🎉 Upcoming Workshop: Master Creative Writing\n\nJoin us for an exclusive, interactive event on [Date]. Learn the secrets of storytelling.', order: 0 },
                { id: now + 1, type: 'image', content: DEFAULT_IMAGE, order: 1 },
                { id: now + 2, type: 'html', content: '<div style="padding: 30px; background: #e0f7fa; text-align: center; border-radius: 10px; margin-top: 20px;">\n  <h3 style="color: #00796b;">Registration Open</h3>\n  <p>Secure your spot before tickets run out!</p>\n  <button style="padding: 10px 24px; background: #007bff; color: white; border: none; border-radius: 5px; font-weight: bold; cursor: pointer;">Register Now</button>\n  <p style="font-size: 12px; margin-top: 10px; color: #6c757d;">(Replace this block with your Eventbrite or form embed code)</p>\n</div>', order: 2 }
            ];
            break;

        default:
            newModules = [];
    }

    return newModules;
};